import { AnchorButton, Collapse } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import * as React from 'react';
import { alphaSort, isEqual } from 'vet-bones/utils';

import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { getLabelForIri } from 'src/containers/ProjectDiagram/utils/labels';
import { useAttributeFieldsContext } from 'src/containers/ProjectMapping/hooks/attributes';
import { useMappingFromRoute } from 'src/containers/ProjectMapping/hooks/useMappingFromRoute';
import { ProjectClassMappingAttributeRow } from 'src/containers/ProjectMapping/ProjectClassMappingAttributeRow';
import { projectLabelsByIriSelector } from 'src/selectors/projectLabelsByIri';
import { projectMappingAttributeFiltersByIriSelector } from 'src/selectors/projectMappingAttributeFilters';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const ProjectClassMappingAttributesSection: React.VFC = () => {
  const { projectId } = useRouterParams();
  const mapping = useMappingFromRoute() as Mapping & { to: string };
  const attributeContextValue = useAttributeFieldsContext();

  const labelsByIri = useReduxSelector(
    projectLabelsByIriSelector(projectId),
    isEqual
  );
  const filtersByIri = useReduxSelector(
    projectMappingAttributeFiltersByIriSelector(projectId, mapping.value)
  );

  const [isOpen, setIsOpen] = React.useState(true);

  const rows = Object.entries(attributeContextValue.fieldValuesByAttribute)
    .filter(([attributeIri]) => filtersByIri[attributeIri] !== false)
    .sort(
      alphaSort(([attributeIri]) => getLabelForIri(labelsByIri, attributeIri))
    )
    .map(([attributeIri, fieldValues], index) => {
      return (
        <ProjectClassMappingAttributeRow
          key={attributeIri}
          attributeIri={attributeIri}
          fieldValues={fieldValues}
          index={index}
        />
      );
    });

  return (
    <div className="sd-project-mapping-collapse">
      <div className="sd-project-mapping-collapse-header">
        <AnchorButton
          disabled={!rows.length}
          icon={isOpen ? IconNames.CHEVRON_DOWN : IconNames.CHEVRON_UP}
          minimal
          onClick={() => setIsOpen(!isOpen)}
          text={copy.components.projectMapping.attributes.section}
        />
      </div>
      <Collapse
        className="sd-project-mapping-collapse-grid--suggestions"
        isOpen={isOpen}
      >
        {rows}
      </Collapse>
    </div>
  );
};
